// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2Zi9c","inputDescription":"styles_inputDescription__ySED_"};